export default __webpack_public_path__ + "static/media/MyDiary.883684cbfc0132fe01893b513c6776ad.webp";